export interface VideoFileInfo {
  width: number;
  height: number;
  duration: number;
}

export async function getVideoInfoByVideoTag(fileURL: string) {
  return new Promise<VideoFileInfo>((resolve, reject) => {
    const video = document.createElement('video');
    setTimeout(() => reject(new Error('浏览器无法解析视频编码')), 1200);

    video.onloadedmetadata = () => {
      if (!video.videoWidth || !video.videoHeight || !video.duration) {
        reject(new Error('浏览器无法解析视频编码'));
      }
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
        duration: video.duration,
      });
    };
    video.src = fileURL;
    video.muted = true;
  });
}

export async function getFramesByVideoTag(
  fileURL: string,
  resizeWidth: number,
  resizeHeight: number,
  startTime: number,
  endTime: number,
  outPutFrameCount: number,
) {
  const frameTimestamps = Array.from(
    { length: outPutFrameCount },
    (_, i) => startTime + (i * (endTime - startTime)) / (outPutFrameCount - 1),
  );
  const start = frameTimestamps[0];
  const outputFrames = [];

  const video = document.createElement('video');
  const videoReady = new Promise((r) => (video.onloadedmetadata = r));
  video.muted = true;
  video.src = fileURL;

  await videoReady;
  const videoPlaying = new Promise((r) => (video.onplaying = r));
  video.currentTime = start;
  video.play();
  await videoPlaying;
  video.pause();
  video.currentTime = start;
  video.onplaying = null;

  //   const delay = (endTime - startTime) / outPutFrameCount;

  // grab frames
  const waitForFrameReady = () => new Promise((r) => (video.onseeked = r));
  for (let i = 0; i < frameTimestamps.length; i++) {
    const frameTime = frameTimestamps[i];
    const seekEnd = waitForFrameReady();
    video.currentTime = frameTime;
    await seekEnd;

    outputFrames.push(await createImageBitmap(video, { resizeWidth, resizeHeight }));
  }

  return outputFrames;
}
